import { render, staticRenderFns } from "./RegistrationDetails.vue?vue&type=template&id=23f5336d&scoped=true&lang=pug&"
import script from "./RegistrationDetails.vue?vue&type=script&lang=js&"
export * from "./RegistrationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f5336d",
  null
  
)

export default component.exports